import { useEffect, useLayoutEffect, useRef } from 'react';

type UseIntervalOptions = {
  leading?: boolean; // If true, run callback immediately on mount
};

export function useInterval(callback: () => void, delay: number | null, options: UseIntervalOptions = {}) {
  const { leading = true } = options;
  const savedCallback = useRef(callback);

  useLayoutEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay === null) return;

    if (leading) {
      savedCallback.current();
    }

    const id = setInterval(() => {
      savedCallback.current();
    }, delay);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(id);
  }, [delay, leading]);
}
